/* lua.js generated code undefined */
 // 202206掉落干预，这里是本地需要保存的数据
// 对于这份数据后端只做存储，不会加工
let DAUserDataV2 = xClass("DAUserDataV2")
let TWO_DAY_TIME = 3600 * 24 * 48
let DATA_KEYS = table(
    [1, "kActive7DayTag", "active7DayTag"],
    [1, "kAtive7DayTagTime", "active7DayTagTime"],
    [1, "kActive30DayTag", "active30DayTag"],
    [1, "kActive30DayTagTime", "active30DayTagTime"],
    [1, "kPaymentTag", "paymentTag"],
    [1, "kPaymentTagTime", "paymentTagTime"],
    [1, "kDifficultyTag", "difficultyTag"],
    [1, "kDifficultyTagTime", "difficultyTagTime"],
    [1, "kLockedPlans", "lockedPlans"],
    [1, "kCdGroups", "cdGroups"],
    // [1, "kLockedPlan", "lockedPlan"],
    // [1, "kLockedPlanTime", "lockedPlanTime"],
    [1, "kLockedSchemes", "lockedSchemes"],
    // [1, "kPlansCD", "plansCD"],
    // [1, "kPlansTypeCD", "plansTypeCD"],
    // [1, "kFirstPassToplvlNum", "firstPassToplvlNum"],
    // [1, "kNotReachFuuuNum", "notReachFuuuNum"],
    [1, "kRecTime", "recTime"],
    [1, "klevelCompleteRatios", "levelCompleteRatios"]
)
let instance = null
DAUserDataV2.getInstance = function () {
    let self = this
    if (!instance) {
        instance = DAUserDataV2.new()
    }
    return instance
}
DAUserDataV2.prototype.ctor = function () {
    let self = this
    for (let k in DATA_KEYS) {
        let v = DATA_KEYS[k]
        if ($null(v)) continue
        // if (v === DATA_KEYS.kPlansCD) {
        //     // 这个字段弃用了，用plansTypeCD代替
        //     self[v] = table()
        // } else 
        if ( v === DATA_KEYS.kLockedPlans || v === DATA_KEYS.kCdGroups || v === DATA_KEYS.kLockedSchemes || v === DATA_KEYS.klevelCompleteRatios) {
            self[v] = table()
        } else {
            self[v] = 0
        }
    }
    // self.clearLockedScheme()
    self.dropAdjustmMetaRef = UserTagData.getInstance().dropAdjustmMetaRef//MetaManager.getInstance().getDropAdjustMeta()
    self.dropAdjustPlanConfig = UserTagData.getInstance().dropAdjustPlanV2 //MetaManager.getInstance().getDropAdjustPlanV2Meta()
    self.planConfigCache = table()
    self.needSync = true
    self.cubeGroups = table()
    self.isOpen = false
    self.isQADiffTag = false
    self.readFromLocal()

    // self.addCdGroup("1",1)
    // self.addCdGroup("3",1)
    // self.addCdGroup("4",1)
    // table.remove(self.cdGroups, 1)
    // self.cdGroups = table.filter(self.cdGroups, function(v, k){
    //     k != "1"
    // })
    // self.cdGroups["1"] = null
    // console.log("【掉落优化】 addCdGroup remove", self.cdGroups)
}

DAUserDataV2.prototype.parseDAUserDataV2 = function (data) {
    let self = this
}
//从本地读取，json字段应该和本结构完全一致
DAUserDataV2.prototype.readFromLocal = function () {
    let self = this
    let data = Localhost.readDAUserDataV2()
    
    // xpcall(function () {
        // data = JSON.parse(data)
    cc.log("【掉落优化】 readFromLocal=" , data)
    // }, function () {
    //     cc.log("【掉落优化】 json解析黄了！！！")
    //     data = table()
    // })
    for (let k in DATA_KEYS) {
        let v = DATA_KEYS[k]
        if ($null(v)) continue
        // if (v === DATA_KEYS.kPlansCD) {
        //     if (type(data[v]) !== "table") {
        //         self[v] = table()
        //     } else {
        //         self[v] = data[v] || table()
        //     }
        // } else 
        if ( v === DATA_KEYS.kLockedPlans || v === DATA_KEYS.kCdGroups || v === DATA_KEYS.kLockedSchemes || v === DATA_KEYS.klevelCompleteRatios) {
            if (type(data[v]) !== "table") {
                self[v] = table()
            } else {
                self[v] = data[v] || table()
            }
        // } else if (v === DATA_KEYS.kLockedSchemes) {
        //     self[v] = tonumber(data[v] || -1)
        } else {
            self[v] = tonumber(data[v] || 0)
        }
    }
    // self.checkChangePlansCD2PlansTypeCD()
    // self.ReadCheckDetailData(data)
    // self.checkLockedPlanExpire()
}
// plansCD老数据转换检查
// DAUserDataV2.prototype.checkChangePlansCD2PlansTypeCD = function () {
//     let self = this
//     let hasOldData = false
//     let hasChangeDate = false
//     if (self[DATA_KEYS.kPlansCD]) {
//         for (let k in self[DATA_KEYS.kPlansCD]) {
//             let v = self[DATA_KEYS.kPlansCD][k]
//             if ($null(v)) continue
//             hasOldData = true
//         }
//         if (hasOldData) {
//             cc.log("【掉落优化】plansCD数据需要转换成plansTypeCD")
//             self[DATA_KEYS.kPlansTypeCD] = table()
//             for (let planID in self[DATA_KEYS.kPlansCD]) {
//                 let cdStart = self[DATA_KEYS.kPlansCD][planID]
//                 if ($null(cdStart)) continue
//                 let planConfig = self.dropAdjustPlanConfig.getPlanConfig(tonumber(planID))
//                 cc.log("【掉落优化】plansCD更新 planID=" + tostring(planID))
//                 if (planConfig) {
//                     let planType = planConfig.test_type
//                     if ((self[DATA_KEYS.kPlansTypeCD][tostring(planType)] === null)) {
//                         self[DATA_KEYS.kPlansTypeCD][tostring(planType)] = cdStart
//                     }
//                 }
//                 hasChangeDate = true
//             }
//             cc.log("【掉落优化】plansTypeCD=" + table.tostring(self[DATA_KEYS.kPlansTypeCD]))
//         }
//         self[DATA_KEYS.kPlansCD] = null
//         if (hasChangeDate) {
//             self.saveAllData()
//         }
//     }
// }
// 保存数据到本地和后端
DAUserDataV2.prototype.saveAllData = function () {
    let self = this
    let data = self.writeToLocal()
    function onSuccess(evt) {
        cc.log("【掉落优化】 保存后端成功")
    }
    let http = SaveDAUserDataV2Http.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.load(data)
}
// 保存到本地，json字段应该和本结构完全一致
DAUserDataV2.prototype.writeToLocal = function () {
    let self = this
    // cc.log("【掉落优化】 DAUserDataV2:writeToLocal")
    self.recTime = Localhost.timeInSec()
    let data = table()
    for (let k in DATA_KEYS) {
        let v = DATA_KEYS[k]
        if ($null(v)) continue
        // if (v === DATA_KEYS.kPlansCD) {
        //     // 弃用了不在保存
        // } else {
            data[v] = self[v]
        // }
    }
    // data.lockedSchemeDetail = self.lockedSchemeDetail
    // xpcall(function () {
        cc.log("【掉落优化】 writeToLocal=" , data)
        data = JSON.stringify($tableToObj(data))
    // }, function () {
    //     cc.log("【掉落优化】 json解析黄了！！！")
    //     data = "{}"
    // })
    Localhost.writeDAUserDataV2(data)
    return data
}

// DAUserDataV2.prototype.ReadCheckDetailData = function (fromData) {
//     let self = this
//     self.lockedSchemeDetail = fromData.lockedSchemeDetail || table([1, "y", 0], [1, "z", 0])
//     if (self.lockedSchemeDetail.y === null) {
//         self.lockedSchemeDetail.y = 0
//     }
//     if (self.lockedSchemeDetail.z === null) {
//         self.lockedSchemeDetail.z = 0
//     }
// }
// levelId可以为空，这样不计算难度标签
DAUserDataV2.prototype.tryRefreshAllTag = function (levelId) {
    let self = this
    // print("【掉落优化】 DAUserDataV2:tryRefreshAllTag")
    if ( self.needSync) {
        // 第一次刷新标签前先尝试从后端获取一次数据，如果后端数据的时间比本地的新，就用后端的
        function onSuccess(evt) {
            // print("【掉落优化】 从后端读取成功"..table.tostring(evt.data))
            self.needSync = false
            if (evt.data && evt.data.data) {
                // xpcall(function () {
                    let data = $table( JSON.parse(evt.data.data))
                    if (data.recTime > self.recTime) {
                        for (let k in DATA_KEYS) {
                            let v = DATA_KEYS[k]
                            if ($null(v)) continue
                            if ( v === DATA_KEYS.kLockedPlans || v === DATA_KEYS.kCdGroups || v === DATA_KEYS.kLockedSchemes || v === DATA_KEYS.klevelCompleteRatios) {
                                if (type(data[v]) !== "table") {
                                    self[v] = table()
                                } else {
                                    self[v] = data[v] || table()
                                }
                            } else {
                                self[v] = tonumber(data[v] || 0)
                            }
                        }
                        console.log("【掉落优化】 从后端更新的数据", JSON.parse(evt.data.data))
                        // for (let k in DATA_KEYS) {
                        //     let v = DATA_KEYS[k]
                        //     if ($null(v)) continue
                        //     if (v === DATA_KEYS.kPlansCD) {
                        //         self[v] = newData[v] || table()
                        //     } else if (v === DATA_KEYS.kPlansTypeCD) {
                        //         self[v] = newData[v] || table()
                        //     } else if (v === DATA_KEYS.kLockedScheme) {
                        //         self[v] = tonumber(newData[v] || -1)
                        //     } else {
                        //         self[v] = tonumber(newData[v] || 0)
                        //     }
                        // }
                        // self.checkChangePlansCD2PlansTypeCD()
                        // self.ReadCheckDetailData(newData)
                    }
                // }, function () { })
            }
            self.tryRefreshAllTag(levelId)
            self.checkAvaliable() //检查本地数据是否与配置一致
        }
        function onFail() {
            self.needSync = false
            self.tryRefreshAllTag(levelId)
            self.checkAvaliable() //检查本地数据是否与配置一致
        }
        let http = GetDAUserDataV2Http.new(true)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onFail)
        http.load()
        return 
    }
    // if self.active7DayTag == 0 then
    let active7Day = UserTagData.getInstance().getTag(UserTagEnum.Active7Day) || 0
    self.tryRefreshActive7DayTag(active7Day)
    let active30Day = UserTagData.getInstance().getTag(UserTagEnum.Active30Day) || 0
    self.tryRefreshActive30DayTag(active30Day)
    // let paymentTag = UserManager.getInstance().getUserTagData().adLabelInfo.labelId || 0
    let paymentTag = UserManager.getInstance().getAdLabelInfo().labelId || 0
    self.tryRefreshPaymentTag(paymentTag)
    if (levelId) {
        let difficultyTagConfig = UserTagData.getInstance().dropAdjustDiffTagV2 //MetaManager.getInstance().getDropAdjustDiffTagV2Meta()
        let difficultyTag = UserTagData.getInstance().getTag(UserTagEnum.PersonalDifficulty, levelId, difficultyTagConfig, 1, 5) || 0
        self.tryRefreshDifficultyTag(difficultyTag)
    }
    // qa修改标签字段  
    // cc.log("【掉落优化】 qa_active7DayTag=" + tostring(self.qa_active7DayTag))
    // cc.log("【掉落优化】 qa_active30Day=" + tostring(self.qa_active30Day))
    // cc.log("【掉落优化】 qa_paymentTag=" + tostring(self.qa_paymentTag))
    if (self.qa_active7DayTag) {
        self.active7DayTag = self.qa_active7DayTag
    }
    if (self.qa_active30DayTag) {
        self.active30DayTag = self.qa_active30DayTag
    }
    if (self.qa_paymentTag) {
        self.paymentTag = self.qa_paymentTag
    }
    // if (self.qa_firstPassToplvlNum) {
    //     self.firstPassToplvlNum = self.qa_firstPassToplvlNum
    // }
    // if (self.qa_notReachFuuuNum) {
    //     self.notReachFuuuNum = self.qa_notReachFuuuNum
    // }
    // self.active7DayTag = 0
    // self.active30DayTag =0
    // self.paymentTag=3001
    // self.difficultyTag=0
    // self.saveAllData()
    cc.log("【掉落优化tag】 active7DayTag=" + tostring(self.active7DayTag))
    cc.log("【掉落优化tag】 active7DayTagTime=" + tostring(self.active7DayTagTime))
    cc.log("【掉落优化tag】 active30DayTag=" + tostring(self.active30DayTag))
    cc.log("【掉落优化tag】 active30DayTagTime=" + tostring(self.active30DayTagTime))
    cc.log("【掉落优化tag】 paymentTag=" + tostring(self.paymentTag))
    cc.log("【掉落优化tag】 paymentTagTime=" + tostring(self.paymentTagTime))
    cc.log("【掉落优化tag】 difficultyTag=" + tostring(self.difficultyTag))
    cc.log("【掉落优化tag】 difficultyTagTime=" + tostring(self.difficultyTagTime))
    cc.log("【掉落优化tag】 getRecentLevelPropConsume=",UserManager.getInstance().getRecentLevelPropConsume())

    
}
// 尝试刷新7天活跃标签，已有的标签48小时内不刷新
DAUserDataV2.prototype.tryRefreshActive7DayTag = function (tag) {
    let self = this
    let now = Localhost.timeInSec()
    if (now - self.active7DayTagTime > self.dropAdjustmMetaRef.active_7daysTag_duration_new || TWO_DAY_TIME) {
        self.active7DayTag = tag
        self.active7DayTagTime = now
    }
}
// 尝试刷新30天活跃标签，已有的标签48小时内不刷新
DAUserDataV2.prototype.tryRefreshActive30DayTag = function (tag) {
    let self = this
    let now = Localhost.timeInSec()
    if (now - self.active30DayTagTime > self.dropAdjustmMetaRef.active_30daysTag_duration_new || TWO_DAY_TIME * 2) {
        self.active30DayTag = tag
        self.active30DayTagTime = now
    }
}
// 尝试刷新付费标签
DAUserDataV2.prototype.tryRefreshPaymentTag = function (tag) {
    let self = this
    let now = Localhost.timeInSec()
    self.paymentTag = tag
    self.paymentTagTime = now
}
// 尝试刷新难度标签
DAUserDataV2.prototype.tryRefreshDifficultyTag = function (tag) {
    let self = this
    let now = Localhost.timeInSec()
    self.difficultyTag = tag
    self.difficultyTagTime = now
}
DAUserDataV2.prototype.getActive7DayTag = function () {
    let self = this
    return self.active7DayTag
}
DAUserDataV2.prototype.getActive30DayTag = function () {
    let self = this
    return self.active30DayTag
}
DAUserDataV2.prototype.getPaymentTag = function () {
    let self = this
    return self.paymentTag
}
DAUserDataV2.prototype.getDifficultyTag = function () {
    let self = this
    return self.difficultyTag
}
// 获取锁定的策略
// DAUserDataV2.prototype.getLockedScheme = function () {
//     let self = this
//     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】获取锁定策略：" + tostring(self.lockedSchemes))
//     return self.lockedSchemes
// }
// DAUserDataV2.prototype.getLockedSchemeDetail = function () {
//     let self = this
//     return self.lockedSchemeDetail
// }
// DAUserDataV2.prototype.clearLockedScheme = function (reason) {
//     let self = this
//     //确认策略0已经是一个特殊的策略，无效值用-1表示
//     self.lockedSchemes = -1
//     self.lockedSchemeDetail = table([1, "y", 0], [1, "z", 0])
//     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】清除锁定策略：" + tostring(self.lockedSchemes))
//     DAManagerGUILogger.getInstance().print("\t\t【掉落优化】清除锁定策略原因：" + tostring(reason))
// }
//到达fuuu的次数 跟产品确认打一关只算一次
// DAUserDataV2.prototype.AddFuuuNum = function () {
//     let self = this
//     if (self.lockedSchemes < 0) {
//         return 
//     }
//     self.lockedSchemeDetail.y = self.lockedSchemeDetail.y + 1
// }
//干预次数，跟产品确认打 一关选中fuuu策略算一次 难度方案没有锁定 无视
// DAUserDataV2.prototype.AddDANum = function () {
//     let self = this
//     if (self.lockedSchemes < 0) {
//         return 
//     }
//     self.lockedSchemeDetail.z = self.lockedSchemeDetail.z + 1
// }

DAUserDataV2.prototype.refreshCdGroups = function (levelId, isWin) {
    let self = this
    // let now = Localhost.timeInSec()
    
    if (levelId) {
        console.log("【掉落优化】开始关末刷新冷却组, 刷新前", $tableToObj(self.cdGroups))
        let digest = LevelConfigManager.getInstance().getLevelDigest(levelId)
        // let hellIdx = digest.isHardLevel ? 1 : 0
        table.each(self.cdGroups, function(value, cdGroup){
            if ($null(value)) return
    
            value.playlvlNum += 1
            value.passDifflvlNum += isWin && digest.isHardLevel ? 1 : 0
            value.passToplvlNum += isWin ? 1 : 0
    
            let lockedPlanConfig = self.getPlanConfig(value.planId)
            let cdArray = lockedPlanConfig.test_cd.split(";")
            let needPassToplvlNum = tonumber(cdArray[1] || 9999)
            let needPassDifflvlNum = tonumber(cdArray[2] || 9999)
            let needPlaylvlNum = tonumber(cdArray[3] || 9999)
            
            if (value.passDifflvlNum >= needPassDifflvlNum){
                self.cdGroups[cdGroup] = null
                console.log("【掉落优化】 冷却组" + cdGroup + "由于通过难关次数>=" + needPassDifflvlNum +"解锁，", "解锁后的冷却组", $tableToObj(self.cdGroups))
            }else if ( value.playlvlNum >= needPlaylvlNum){
                self.cdGroups[cdGroup] = null
                console.log("【掉落优化】 冷却组" + cdGroup + "由于打关次数>=" + needPlaylvlNum + "解锁，", "解锁后的冷却组",$tableToObj(self.cdGroups))
            }else if (value.passToplvlNum >= needPassToplvlNum){
                self.cdGroups[cdGroup] = null
                console.log("【掉落优化】 冷却组" + cdGroup + "由于通过最高关次数" + needPassToplvlNum +"解锁，", "解锁后的冷却组",$tableToObj(self.cdGroups))
            }
    
        })
    }else{
        console.log("【掉落优化】开始刷新冷却组时间, 刷新前", $tableToObj(self.cdGroups))
        table.each(self.cdGroups, function(value, cdGroup){
            if ($null(value)) return
            let lockedPlanConfig = self.getPlanConfig(value.planId)
            let cdArray = lockedPlanConfig.test_cd.split(";")
            let expireTime = value.enterTime + tonumber(cdArray[0] || 0)
    //     let cdTime = tonumber(config.test_cd) || 0
            let now = Localhost.timeInSec()
    //     DAManagerGUILogger.getInstance().print("【掉落优化】 expireTime=" + tostring(expireTime))
    //     DAManagerGUILogger.getInstance().print("【掉落优化】 cdTime=" + tostring(cdTime))
    //     DAManagerGUILogger.getInstance().print("【掉落优化】 now=" + tostring(now))
    //     let expiredTime = now - self.lockedPlanTime - expireTime
    //     if (expiredTime >= 0) {
            if (now > expireTime){ 
                self.cdGroups[cdGroup] = null
                console.log("【掉落优化】 冷却组" + cdGroup + "进入冷却时间" + value.enterTime, "由于已过期而出冷却，出冷却后的冷却组",$tableToObj(self.cdGroups))
            }
        })
    }



}
//NOTE：该函数为清除当前锁定方案，设置cd。如果单独设置cd长度（应该没这需求），不能调用该函数, 进入冷却组
DAUserDataV2.prototype.addCdGroup = function (cdGroup, planId) {
    let self = this
    //刚进入冷却组
    if (self.cdGroups[cdGroup]){
        console.log("【掉落优化】 addCdGroup错误 已在cdgroup", $tableToObj(self.cdGroups), cdGroup)
    }else {
        // let cdArray = test_cd.split(";")
        // let expiredTime = tonumber(cdArray[0]) + Localhost.timeInSec()
        let enterTime = Localhost.timeInSec()
        // let needPassToplvlNum = tonumber(cdArray[1] || 9999)
        // let needPassDifflvlNum = tonumber(cdArray[2] || 9999)
        // let needPlaylvlNum = tonumber(cdArray[3] || 9999)
        self.cdGroups[cdGroup] = {
            "passToplvlNum" : 0,
            "passDifflvlNum" : 0,
            "playlvlNum" : 0,
            "enterTime" : enterTime,
            "planId" : planId

        } 
        console.log("【掉落优化】 新增冷却组", cdGroup, "所有冷却组：", $tableToObj(self.cdGroups))
        // self.cdGroups["s"] = "s"
        // self.saveAllData()

    }
   
}
// 设置cube分组
DAUserDataV2.prototype.setCubeGroup = function () {
    let self = this
    // if (!ReachabilityUtil.getInstance().isNetworkAvailable()) {
    //     for (let k in self.dropAdjustPlanConfig.cubeGroups) {
    //         let v = self.dropAdjustPlanConfig.cubeGroups[k]
    //         if ($null(v)) continue
    //         self.cubeGroups[k] = "a"
    //     }
    //     return 
    // }
    // CubeOrthGroupHelper.getInstance().requestTestGroup(CubeExperimentConst.interveneTestMutex, function (data) {
    //     // 目前虽然会遍历一个个去请求cube分组，但是目前只会有一个cube分组，所以实际只会请求一次
    //     if (data.group !== "") {
    //         // 进入了互斥组
    //         cc.log("【掉落优化】进入互斥组", "DAV2")
    //     } else {

    //为了bcdefg..分组玩家断关续打变成a分组时，此次登录按原分组算，下次登录才为a分组
    try {
        var lastBatchReplay = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_BATCH_REPLAY_IN_LEVEL)
        var current = new Date().getTime()
        lastBatchReplay = JSON.parse(lastBatchReplay)        
        var replayTime = lastBatchReplay.createTime
        var expireTime = replayTime + 72 * 60 * 60 * 1000 // 72小时内可以恢复
        var expireTimeFriendPvp = replayTime + 5 * 60 * 1000 // 友谊赛5分钟内可以恢复
        var replayFileUid = lastBatchReplay.uid
        var currentUid = UserManager.getInstance().uid

        var replay = JSON.parse(lastBatchReplay.replay)[1]
        var newLevelEnd = replay.newLevelEnd         
        // if (replay){
        //     DCAssist.dcForStageRecord(3, replay)
        // }
        replay = $table(replay)
        replay.newLevelEnd = newLevelEnd
        if (current < expireTime && currentUid == replayFileUid && replay.level) {
            // 检查关卡数
            var levelId = replay.level
            // 检查MD5
            let md5 = ResManager.getLevelMd5(levelId)
            if (md5 == replay.lvmd5) {
                if (levelId >= LevelConstans.FRIEND_PVP_LEVEL_ID_S && levelId <= LevelConstans.FRIEND_PVP_LEVEL_ID_E && current < expireTimeFriendPvp) // 友谊赛
                {
                    lastBatchReplay.replay = replay
                    self.replayFile = lastBatchReplay
                    
                }
                if ((levelId > 0 && levelId < 20000) || // 普通关卡，蓝鲸
                    (levelId > 80000 && levelId < 80021)  || // 七夕关
                    (levelId >= LevelConstans.ACTIVITY_GOLD_ID_S && levelId <= LevelConstans.ACTIVITY_GOLD_ID_E) // 金币关
                ){
                    lastBatchReplay.replay = replay
                    self.replayFile = lastBatchReplay
                    // 没有过期
                    
                }
            }
        }

        if (self.replayFile){
            console.log("掉落replay", self.replayFile)
            
        }
    } catch (e) {
        cc.log(e);
    }

            for (let k in self.dropAdjustPlanConfig.cubeGroups) {
                let v = self.dropAdjustPlanConfig.cubeGroups[k]
                if ($null(v)) continue
                CubeOrthGroupHelper.getInstance().requestTestGroup(CubeExperimentConst[k], function (data) {
                    // group = "g"

                    if (self.replayFile && self.replayFile.replay && self.replayFile.replay.dropAdjustCube != "a" && data.group == "a"){
                        data.group = self.replayFile.replay.dropAdjustCube
                        console.log("掉落replay 强行将分组从a换为", data.group)
                    }

                    let scene = cc.Director.getInstance().getRunningScene()
                    cc.log("【掉落优化】 cube分组：" + tostring(data.group) + "，当前场景：" + tostring(scene && scene.name))
                    if ((scene && scene.name !== "PreloadScene" && scene.name !== "HomeScene") || data.group === "a") {
                        // 分组返回只有在登录和大地图界面才能生效，否则走老干预
                        // a组走干预
                        return 
                    }
                    self.isOpen = true
                    self.cubeGroups[k] = data.group
                    UserTagData.getInstance().dropAdjustmMetaRef.changeToV2()
                    _G.DAManager = require("clover/gamePlay/DropAdjust/DAManagerV2")
                    _G.DAManager.getInstance().cubeGroup = data.group
                    // DAManager.getInstance().tryUpdateData()
                    self.tryRefreshAllTag()
                    
                }, "a")
            }
    //     }
    // }, "")
}
// qa测试用强制开启
// DAUserDataV2.prototype.qaOpen = function () {
//     let self = this
//     self.isOpen = true
//     UserTagData.getInstance().dropAdjustmMetaRef.changeToV2()
//     _G.DAManager = require("clover/gamePlay/DropAdjust/DAManagerV2")
//     // DAManager.getInstance().tryUpdateData()
//     self.checkChangePlansCD2PlansTypeCD()
//     self.tryRefreshAllTag()
//     cc.log("【掉落优化】 切换到新掉落干预")
//     DAManagerGUILogger.getInstance().print("【掉落优化】 切换到新掉落干预")
// }

//检查冷却组，锁定策略，锁定方案，数据是否对的上配置
DAUserDataV2.prototype.checkAvaliable = function () {
    let self = this

    // let correct = true
    table.each(self.lockedSchemes, function(value, cdGroup){
        if ($null(value)) return

        let lockedPlanConfig = self.getPlanConfig(value.planId)
        if ( !lockedPlanConfig || lockedPlanConfig.cd_group != cdGroup || lockedPlanConfig.test_type != value.test_type){
            cc.log("【掉落优化】 由于锁定策略(冷却组为" + tostring(cdGroup) + ")的cdgroup或方案类型或方案id与配置不一致，", $tableToObj(self.lockedSchemes), "清除锁定策略方案冷却组")
            self.lockedSchemes = table()
            self.lockedPlans = table()
            self.cdGroups = table()
        }
    })

    table.each(self.lockedPlans, function(value, cdGroup){
        if ($null(value)) return

        let lockedPlanConfig = self.getPlanConfig(value.planId)
        if ( !lockedPlanConfig || lockedPlanConfig.cd_group != cdGroup || lockedPlanConfig.test_type != value.test_type){
            cc.log("【掉落优化】 由于锁定方案(冷却组为" + tostring(cdGroup) + ")的cdgroup或方案类型或方案id与配置不一致，", $tableToObj(self.lockedPlans), "清除锁定策略方案冷却组")
            self.lockedSchemes = table()
            self.lockedPlans = table()
            self.cdGroups = table()
        }
    })

    table.each(self.cdGroups, function(value, cdGroup){
        if ($null(value)) return

        let lockedPlanConfig = self.getPlanConfig(value.planId)
        if ( !lockedPlanConfig || lockedPlanConfig.cd_group != cdGroup){
            cc.log("【掉落优化】 由于冷却组" + tostring(cdGroup) + "的cdgroup或方案id与配置不一致，", $tableToObj(self.cdGroups), "清除锁定策略方案冷却组")
            self.lockedSchemes = table()
            self.lockedPlans = table()
            self.cdGroups = table()
        }
    })
    cc.log("【掉落优化】 检查配置后的冷却组",$tableToObj(self.cdGroups), "锁定方案",$tableToObj(self.lockedPlans), "锁定策略", $tableToObj(self.lockedSchemes))
}
DAUserDataV2.prototype.refreshLockedSchemas = function (levelId, isWin, fuuuReached) {
    let self = this
    console.log("【掉落优化】开始关末刷新锁定策略, 刷新前", $tableToObj(self.lockedSchemes))
    table.each(self.lockedSchemes, function(value, cdGroup){
        if ($null(value)) return

        let lockedPlanConfig = self.getPlanConfig(value.planId)
        value.playlvlNum += 1
        value.reachFuuuNum += fuuuReached ? 1 : 0

        if (isWin && value.levelId != levelId){
            console.log("【掉落优化】解锁策略严重错误 快看看什么原因", $tableToObj(self.lockedSchemes), levelId)
        }
        if (isWin && value.levelId == levelId){
            self.unlockLockedSchema(null, value.cdGroup, "levelId", value.levelId)
        }else if (value.playlvlNum >= tonumber( lockedPlanConfig[value.z])){
            self.unlockLockedSchema(null, value.cdGroup, "playlvlNum", value.playlvlNum)
        }else if (value.reachFuuuNum  >= tonumber( lockedPlanConfig[value.y])){
            self.unlockLockedSchema(null, value.cdGroup, "reachFuuuNum", value.reachFuuuNum)
        }


    })
}
DAUserDataV2.prototype.lockSchema = function (strategy, plan, levelId, y, z) {
    let self = this

    let cdgroup = plan.cd_group
    if (self.lockedSchemes[cdgroup]){
        console.log("【掉落优化】 addLockedSchema错误 当前cdgroup已有方案", $tableToObj(self.lockedSchemes), cdgroup)
    }else {
        self.lockedSchemes[cdgroup] = {
            // "passToplvlNum" : 0,
            "planId" : plan.id,
            // "passDifflvlNum" : 0,
            "playlvlNum" : 0,
            "reachFuuuNum" : 0,
            "cdGroup" : cdgroup,
            "levelId" : levelId,
            "strategy" : plan[strategy],
            "y" : y,
            "z" : z,
            "test_type" : plan.test_type
            // "expiredTime" : now + tonumber(plan.test_para1)
        }
        // self.saveAllData()
        // self.lockedSchemes["s"] = "s"

    }
    console.log("【掉落优化】 新增锁定策略(cdgroup为",cdgroup, ")，增加后的锁定策略为", $tableToObj(self.lockedSchemes))
    return [self.lockedSchemes[cdgroup]["strategy"], plan.test_type]

}

DAUserDataV2.prototype.unlockLockedSchema = function (planId, cdGroup, reason, reasonValue) {
    let self = this
    if (planId){
        table.each(self.lockedSchemes, function(v, k){
            if ($null(v)) return

            if (v.planId == planId){
                self.lockedSchemes[k] = null
                console.log("【掉落优化】策略（cdgroup为", v.cdGroup, "）由于方案" + planId + "解锁而解锁, 解锁后的锁定策略为", $tableToObj(self.lockedSchemes))
            }
        })
        
    }

    
    if (cdGroup && self.lockedSchemes[cdGroup]){
        let tmpSchema = table.clone(self.lockedSchemes[cdGroup])

        self.lockedSchemes[cdGroup] = null

        if (reason == "levelId"){
            console.log("【掉落优化】策略（cdgroup为", cdGroup, "）由于通过关卡", reasonValue, "而解锁, 解锁后的锁定策略为", $tableToObj(self.lockedSchemes))
    
        }else  if (reason == "playlvlNum"){
            console.log("【掉落优化】策略（cdgroup为", cdGroup, "）由于打关次数", reasonValue, "而解锁, 解锁后的锁定策略为", $tableToObj(self.lockedSchemes))
    
        }else  if (reason == "reachFuuuNum"){
            console.log("【掉落优化】策略（cdgroup为", cdGroup, "）由于达到fuuu次数", reasonValue, "而解锁, 解锁后的锁定策略为", $tableToObj(self.lockedSchemes))
    
        }
        
        //策略由其他原因解锁时需增加方案解锁次数
        if (tmpSchema.test_type == 2){
            let cdGroup = tmpSchema.cdGroup
            if (self.lockedPlans[cdGroup] && self.lockedPlans[cdGroup].planId == tmpSchema.planId){
                self.lockedPlans[cdGroup].schemaUnlockNum += 1
                console.log("【掉落优化】策略（cdgroup为", cdGroup, "）解锁后，对应方案需增加解锁次数, 增加后的锁定方案为", $tableToObj(self.lockedPlans))
            }else {
                console.log("【掉落优化】error又有问题了 解锁策略时增加方案解锁次数", tmpSchema, $tableToObj(self.lockedPlans))
            }
        }
    }

    // self.saveAllData()
    

}
//解锁方案，且对应方案进入冷却组
DAUserDataV2.prototype.unlockLockedPlan = function (plan, lockedPlanConfig, reason, reasonValue) {
    let self = this

    if (self.lockedPlans[plan.cdGroup] && plan.planId == self.lockedPlans[plan.cdGroup]["planId"]){
        
        self.lockedPlans[plan.cdGroup] = null

        if (reason == "passToplvlNum"){
            console.log("【掉落优化】方案（planId为", plan.planId, "）由于通过最高关次数>= " + reasonValue +"而解锁", plan.planId, "解锁后的锁定方案",  $tableToObj(self.lockedPlans))
        }else if (reason == "schemaUnlockNum"){
            console.log("【掉落优化】方案（planId为", plan.planId, "）由于方案内策略解锁次数>= " + reasonValue +"而解锁", plan.planId, "解锁后的锁定方案",  $tableToObj(self.lockedPlans))
        }else if (reason == "time"){
            console.log("【掉落优化】方案（planId为", plan.planId, "）由于方案过期而解锁", "其锁定时间为：", reasonValue,"解锁后的锁定方案",  $tableToObj(self.lockedPlans))
        }
        
        self.unlockLockedSchema(plan.planId)
        self.addCdGroup(lockedPlanConfig.cd_group, plan.planId)

    }else{
        console.log("【掉落优化】error, 解锁方案不存在", plan, $tableToObj(self.lockedPlans))
    }
    // self.saveAllData()
    return null
}

DAUserDataV2.prototype.checkPassTopLevelNum = function(passToplvlNum, x, planId) {
    console.log("【掉落优化】 本锁定方案" + planId + "首次过最高关次数:", passToplvlNum, " 比较参数:", x, " 比较结果:", tonumber(passToplvlNum) >= tonumber(x))
    return tonumber(passToplvlNum) >= tonumber(x)
}

DAUserDataV2.prototype.refreshLockedPlans = function (levelId, isWin) {
    let self = this
    
    if (levelId){
        console.log("【掉落优化】开始关末刷新锁定方案，刷新前", $tableToObj(self.lockedPlans))
        table.each(self.lockedPlans, function(value, cdGroup){
            if ($null(value)) return
    
            if (value.test_type == 1 && isWin){ //方案类型1的用过关次数解锁
                value.passToplvlNum += 1
                let lockedPlanConfig = self.getPlanConfig(value.planId)
                if (self.checkPassTopLevelNum(value.passToplvlNum, lockedPlanConfig.test_para9, value.planId)){
                    DAManager.getInstance().test_para9ForDC = 'y'
                    self.unlockLockedPlan(value, lockedPlanConfig, "passToplvlNum", value.passToplvlNum)
                }else {
                    DAManager.getInstance().test_para9ForDC = 'n'
                }
            }
    
            if (value.test_type == 2){ //方案类型2的用策略解锁次数解锁
                let lockedPlanConfig = self.getPlanConfig(value.planId)
                if (value.schemaUnlockNum >= tonumber(lockedPlanConfig.test_para8)){
                    self.unlockLockedPlan(value, lockedPlanConfig, "schemaUnlockNum", value.schemaUnlockNum)
                }
            }
        })
    }else {
        console.log("【掉落优化】开始刷新锁定方案时间，刷新前", $tableToObj(self.lockedPlans))
        table.each(self.lockedPlans, function(value, cdGroup){
            if ($null(value)) return
            let lockedPlanConfig = self.getPlanConfig(value.planId)
            let expireTime = value.enterTime + tonumber(lockedPlanConfig.test_para1)
            let now = Localhost.timeInSec()
            if (now > expireTime){ 
                self.unlockLockedPlan(value, lockedPlanConfig, "time", value.enterTime)
            }
        })
    }


}
DAUserDataV2.prototype.addLockedPlan = function (plan) {
    let self = this

    let cdgroup = plan.cd_group
    // let now = Localhost.timeInSec()
    if (self.lockedPlans[cdgroup]){
        console.log("【掉落优化】 error addLockedPlan错误 当前cdgroup已有方案", $tableToObj(self.lockedPlans), cdgroup)
    }else {
        self.lockedPlans[cdgroup] = {
            "planId" : plan.id,
            "cdGroup" : cdgroup,
            "enterTime" : Localhost.timeInSec(),
            "test_type" : plan.test_type
        }

        if (plan.test_type == 1){
            self.lockedPlans[cdgroup]["passToplvlNum"] = 0
        }else if (plan.test_type == 2){
            self.lockedPlans[cdgroup]["schemaUnlockNum"] = 0
        }else {
            console.log("【掉落优化】 error 锁定方案类型不为1或2")
        }
        // self.saveAllData()
        // self.lockedPlans["s"] = "s"

    }
    console.log("【掉落优化】 新增锁定方案(planId为" + plan.id, "), 增加后的锁定方案为", $tableToObj(self.lockedPlans))
    return self.lockedPlans[cdgroup]

}
//增加记录的关卡完成度
DAUserDataV2.prototype.getCompleteRatios = function (levelId) {
    let self = this
    return self.levelCompleteRatios[levelId] || table()
}
//增加记录的关卡完成度
DAUserDataV2.prototype.addCompleteRatio = function (levelId) {
    let self = this
    // if (self.lockedSchemes < 0) 
    let targetCount = DATargetCounterV2.getInstance().getCurrentTargetCount()
    let targetComplete = UserManager.getInstance().userLabel.targetComplete || 999
    let completeRatio = Math.floor(targetCount / targetComplete * 1000) / 1000
    // let completeRatio = targetCount 
    if (!self.levelCompleteRatios[levelId]){
        self.levelCompleteRatios = table()
        self.levelCompleteRatios[levelId] = table()
    }
    if ($len(self.levelCompleteRatios[levelId]) >= 100){
        table.remove(self.levelCompleteRatios[levelId], 1)
    }
    table.insert(self.levelCompleteRatios[levelId], completeRatio)
    console.log("【掉落优化】 当前关", levelId, "更新完成度后：" ,self.levelCompleteRatios)
}

DAUserDataV2.prototype.checkLockedPlan = function (plan) {
    let self = this

    let cdgroup = plan.cd_group
    if (self.lockedPlans[cdgroup]){
        console.log("【掉落优化】预选择方案冷却组" + cdgroup + "中有锁定方案", self.lockedPlans[cdgroup].planId)
        return self.lockedPlans[cdgroup]
    }
    console.log("【掉落优化】预选择方案冷却组" + cdgroup + "中无锁定方案")
    return null
}
DAUserDataV2.prototype.checkLockedSchema = function (plan) {
    let self = this
    // self.checkLockedPlanExpire()
    let cdgroup = plan.cd_group
    if (self.lockedSchemes[cdgroup]){
        console.log("【掉落优化】预选择方案冷却组" + cdgroup + "中有锁定策略", self.lockedSchemes[cdgroup]["strategy"])
        return [self.lockedSchemes[cdgroup]["strategy"], self.lockedSchemes[cdgroup]["test_type"]]
    }
    console.log("【掉落优化】预选择方案冷却组" + cdgroup + "中无锁定策略")
    return [null, null]
}
// 获取锁定的方案和锁定的时间点，这里会检查锁定方案是否过期
//planId 选出的方案
//cdgroup 方案所在冷却组
// DAUserDataV2.prototype.getLockedPlan = function (planId ,cdgroup) {
//     let self = this
//     self.checkLockedPlanExpire()

//     let finalPlan
//     table.each(self.lockedPlans, function(lockedPlan){
//         // console.log("【掉落优化】 checkLockedPlanExpire lockedPlan=", lockedPlan)
//         if (lockedPlan.cdgroup == cdgroup){
//             finalPlan = lockedPlan.planId
//             return
//         }
//         // if (reward.score <= self.info.score && reward.status != 1){
//         //    need = true
//         // }
//     })

    
//     cc.log("【掉落优化】getLockedPlan lockedPlan：", finalPlan || planId)
//     return finalPlan || planId
//     // FIXME: multi result
//     return [self.lockedPlan, self.lockedPlanTime]
// }

// 获取指定方案配置
DAUserDataV2.prototype.getPlanConfig = function (planId) {
    let self = this

    if (self.planConfigCache[planId]){
        return self.planConfigCache[planId]
    }
    
    for (let type in self.dropAdjustPlanConfig.configs) {
        let configs = self.dropAdjustPlanConfig.configs[type]
        if ($null(configs)) continue
        for (let k in configs) {
            let v = configs[k]
            if ($null(v)) continue
            if (tonumber(v.id) === planId){
                self.planConfigCache[planId] = v
                return  v
            }
        }
    }

    return null

}
// 获取所有方案集合
// DAUserDataV2.prototype.getAllPlans = function () {
//     let self = this
    
//     return self.dropAdjustPlanConfig.configs
//     if (self.allPlans) {
//         return self.allPlans
//     }

//     let plans = table()
//     for (let type in self.dropAdjustPlanConfig.configs) {
//         let configs = self.dropAdjustPlanConfig.configs[type]
//         if ($null(configs)) continue
//         if (plans[type] === null) {
//             plans[type] = table()
//         }
//         for (let k in configs) {
//             let v = configs[k]
//             if ($null(v)) continue
//             table.insert(plans[type], table.clone(v))
//         }
//     }
//     self.allPlans = plans
//     cc.log("【掉落优化】 getAllPlans", plans)
//     return plans
// }
// 获取分组可用的方案集合，未处于冷却的，平台符合的，并按互斥组分类
DAUserDataV2.prototype.getAvaliablePlans = function () {
    let self = this
    
    //不填参数，用时间刷新
    self.refreshLockedPlans()
    self.refreshCdGroups()
    

    // let now = Localhost.timeInSec()
    let plans = table()
    for (let type in self.dropAdjustPlanConfig.configs) {
        let configs = self.dropAdjustPlanConfig.configs[type]
        if ($null(configs)) continue
        if (!plans[type]) {
            plans[type] = table()
        }
        for (let k in configs) {
            let v = configs[k]
            if ($null(v)) continue

            if (self.cdGroups[v.cd_group]){
                console.log("【掉落】方案" + v.id + "在冷却组")
            }
            
            // else if (!self.checkCubegroup(v)){
            //     console.log("【掉落】方案" + v.id + "cube分组不符合")
            // }else if (!self.checkPlatform(v)){
            //     console.log("【掉落】方案" + v.id + "平台不符合")
            // }
            if (!self.cdGroups[v.cd_group] && self.checkCubegroup(v) && self.checkPlatform(v)) {
                table.insert(plans[type], table.clone(v))
            }
        }
    }
    // cc.log("【掉落优化】 self.dropAdjustPlanConfig.configs", self.dropAdjustPlanConfig.configs)
    cc.log("【掉落优化】 cube分组合适的 未处于冷却的 平台符合的 按互斥组分类的方案getAvaliablePlans", plans)
    return plans
}

DAUserDataV2.prototype.checkPlatform = function (v) {
    let self = this
    let supportSys = v.platform_tag1.split(';');
    let supportPlat = v.platform_tag2.split(';');

    if (v.platform_tag1 != "all" && (!supportSys.includes("ios") && isPlatformIOS() || !supportSys.includes("android") && !isPlatformIOS())){
        console.log("【掉落】方案" + v.id + "平台不符合")
        return false
    }
    if (v.platform_tag2 != "all" && !supportPlat.includes(getCurrentPlatform())) {
        console.log("【掉落】方案" + v.id + "平台不符合")
        return false
    }

    return true
}
DAUserDataV2.prototype.checkCubegroup = function (config) {
    let self = this
    if (string.isEmpty(config.cube_test_id)) {
        // cc.log("【掉落优化】 cube id:" + tostring(config.id))
        DAManagerGUILogger.getInstance().print("【掉落优化】 cube id:" + tostring(config.id))
        return true
    }
    if (config.cube_test_switch && type(config.cube_test_switch) === "table") {
        let curGroup = self.cubeGroups[config.cube_test_id]
        if (curGroup) {
            for (let k in config.cube_test_switch) {
                let v = config.cube_test_switch[k]
                if ($null(v)) continue
                if (v === curGroup) {
                    // print("【掉落优化】 find cube:"..tostring(curGroup).." id:"..tostring(config.id))
                    // DAManagerGUILogger:getInstance():print("【掉落优化】 find cube:"..tostring(curGroup).." id:"..tostring(config.id))
                    //debug.debug()
                    return true
                }
            }
        }
    }
    //print("check cube group failed config.cube:"..tostring(config.cube_test_id).." id:"..tostring(config.id))
    //debug.debug()
    console.log("【掉落】方案" + config.id + "cube分组不符合")
    return false
}

module.exports = table([0, DAUserDataV2], [0, DATA_KEYS])
